/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Generalaccess1Inputs */

const zh_share_generalaccess1 = /** @type {(inputs: Share_Generalaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通用访问权限`)
};

const en_share_generalaccess1 = /** @type {(inputs: Share_Generalaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General access`)
};

const es_share_generalaccess1 = /** @type {(inputs: Share_Generalaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso general`)
};

/**
* | output |
* | --- |
* | "General access" |
*
* @param {Share_Generalaccess1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_generalaccess1 = /** @type {((inputs?: Share_Generalaccess1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Generalaccess1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_generalaccess1(inputs)
	if (locale === "en") return en_share_generalaccess1(inputs)
	return es_share_generalaccess1(inputs)
});
export { share_generalaccess1 as "share_generalAccess" }